import type { Field } from './Fields/Field';
import { EObject, EObjectBuilder } from './EObject';
import type { Method } from './Method';
import type { Reference } from './Reference';

export enum EClassType {
  'STANDARD' = 'STANDARD',
  'INTERFACE' = 'INTERFACE',
}
/**
 * Classe que define as Classes do Explorer.
 * @author daphine.fiuza
 * @author gabriel.carmo
 */
export class EClass extends EObject {
  public static CLASS_ID = '000000000000000000000000';

  /** Identificador da classe.*/
  identifier: string;

  /** Nome da classe.*/
  name: string;

  /** Tipo da classe.*/
  type: EClassType;

  /** Array de fields da classe.*/
  fields: string[];

  /** Referência para o pacote. */
  package: Reference;

  /** Array de métodos. */
  methods: Method[];

  /** Interfaces implementadas. */
  implements: Reference[];

  /** Classe é indexável? */
  index: boolean;

  /** View específica para visualização de objetos. */
  objectDetailsView: Reference;

  historyExpiration: number;

  /** Campo de ajuda para edição de objeto.*/
  editHelp: string;

  constructor(data?: any) {
    super(data);
  }
}

export class EClassBuilder extends EObjectBuilder<EClass> {
  constructor(data?: Partial<Field>) {
    super(data);
    this.class({ _id: EClass.CLASS_ID, _classId: EClass.CLASS_ID });
  }

  name(name: string) {
    this.object.name = name;
    return this;
  }

  identifier(identifier: string) {
    this.object.identifier = identifier;
    return this;
  }

  fields(fields: Partial<Field>[]) {
    this.object.fields = fields;
    return this;
  }
}
